import { render, staticRenderFns } from "./CUGudang.vue?vue&type=template&id=5034f37e&scoped=true&"
import script from "./CUGudang.vue?vue&type=script&lang=js&"
export * from "./CUGudang.vue?vue&type=script&lang=js&"
import style0 from "./CUGudang.vue?vue&type=style&index=0&id=5034f37e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5034f37e",
  null
  
)

export default component.exports